import { PageMap } from '../navigation-data';
import { PageKey } from '../page-keys';
import { Dashboard } from './page-navigation/dashboard-navigation';
import { CalendarView, ListView, TimeTracking } from './page-navigation/time-tracking-navigation';
import {
  ProjectAdd,
  ProjectAttachments,
  ProjectEdit,
  ProjectExpenses,
  ProjectOverview,
  ProjectProgress,
  Projects,
} from './page-navigation/projects-navigation';
import { ClientAdd, ClientEdit, ClientList, Clients } from './page-navigation/clients-navigation';
import {
  Team,
  TeamAbsencePlanner,
  TeamAbsences,
  TeamLeaveRequests,
  TeamMemberAdd,
  TeamOverview,
  TeamVacationQuota,
} from './page-navigation/team-navigation';
import {
  UserProfile,
  UserProfileAttachments,
  UserProfileEdit,
} from './page-navigation/user-profile-navigation';
import { Settings, SettingsNonworkingTime } from './page-navigation/settings-navigation';
import {
  Reports,
  ReportsTimetableAggregated,
  ReportsTimetableMonthly,
  ReportsTimetableTimeEntries,
} from './page-navigation/reports-navigation';
import {
  Finances,
  FinancesExpenses,
  FinancesInvoicesAdd,
  FinancesInvoicesOverview,
} from './page-navigation/finance-navigation';
import { TodoPlanner } from './page-navigation/todo-planner-navigation';

export const pageMap = new PageMap([
  [PageKey.DashboardPageKeys.Dashboard, Dashboard],
  // Time Tracking
  [PageKey.TimeTrackingPageKeys.TimeTracking, TimeTracking],
  [PageKey.TimeTrackingPageKeys.CalendarView, CalendarView],
  [PageKey.TimeTrackingPageKeys.ListView, ListView],
  // Projects
  [PageKey.ProjectPageKeys.Projects, Projects],
  [PageKey.ProjectPageKeys.ProjectOverview, ProjectOverview],
  [PageKey.ProjectPageKeys.ProjectAdd, ProjectAdd],
  [PageKey.ProjectPageKeys.ProjectProgress, ProjectProgress],
  [PageKey.ProjectPageKeys.ProjectEdit, ProjectEdit],
  [PageKey.ProjectPageKeys.ProjectExpenses, ProjectExpenses],
  [PageKey.ProjectPageKeys.ProjectAttachments, ProjectAttachments],
  // Clients
  [PageKey.ClientPageKeys.Clients, Clients],
  [PageKey.ClientPageKeys.ClientList, ClientList],
  [PageKey.ClientPageKeys.ClientAdd, ClientAdd],
  [PageKey.ClientPageKeys.ClientEdit, ClientEdit],
  // Team
  [PageKey.TeamPageKeys.Team, Team],
  [PageKey.TeamPageKeys.TeamOverview, TeamOverview],
  [PageKey.TeamPageKeys.TeamMemberAdd, TeamMemberAdd],
  [PageKey.TeamPageKeys.TeamAbsences, TeamAbsences],
  [PageKey.TeamPageKeys.TeamAbsencePlanner, TeamAbsencePlanner],
  [PageKey.TeamPageKeys.TeamVacationQuota, TeamVacationQuota],
  [PageKey.TeamPageKeys.TeamLeaveRequests, TeamLeaveRequests],
  // Finances
  [PageKey.FinancePageKeys.Finances, Finances],
  [PageKey.FinancePageKeys.FinancesInvoicesOverview, FinancesInvoicesOverview],
  [PageKey.FinancePageKeys.FinancesInvoicesAdd, FinancesInvoicesAdd],
  [PageKey.FinancePageKeys.FinancesExpenses, FinancesExpenses],
  // User Profile
  [PageKey.UserProfilePageKeys.UserProfile, UserProfile],
  [PageKey.UserProfilePageKeys.UserProfileEdit, UserProfileEdit],
  [PageKey.UserProfilePageKeys.UserProfileAttachments, UserProfileAttachments],
  // Settings
  [PageKey.SettingsPageKeys.Settings, Settings],
  [PageKey.SettingsPageKeys.SettingsNonworkingTime, SettingsNonworkingTime],
  // Reports
  [PageKey.ReportsPageKeys.Reports, Reports],
  [PageKey.ReportsPageKeys.ReportsTimetableAggregated, ReportsTimetableAggregated],
  [PageKey.ReportsPageKeys.ReportsTimetableMonthly, ReportsTimetableMonthly],
  [PageKey.ReportsPageKeys.ReportsTimetableTimeEntries, ReportsTimetableTimeEntries],
  // TodoPlanner
  [PageKey.TodoPlannerPageKeys.TodoPlanner, TodoPlanner],
]);
